<script>
import { Doughnut } from 'vue-chartjs'
export default {
	extends: Doughnut,
	props: ['data'],
	watch: {
        data : {
            handler() {
                this.getDurationTypeCount();
            }
        }
    },
    methods: {
        getDurationTypeCount() { 
                this.datacollection.labels = [+this.data.permanent_percent+"%"+" Permanent ("+ this.data.count_permanent+")", +this.data.temporary_percent+"%"+" Temporary ("+ this.data.count_temporary+")"];
                this.datacollection.datasets[0].data[0] = this.data.count_permanent;
                this.datacollection.datasets[0].data[1] = this.data.count_temporary;
                this.renderChart(this.datacollection, {
                    responsive: true,maintainAspectRatio: false, legend: {position: 'top',labels: {
                        boxWidth:20,
                        fontSize:13,fontStyle:"bold",
                    }},
                animation: {
                    duration:0
                },
                    tooltips:{enabled:true,
                                                            mode:'single',
                                                            callbacks:{label:function(tooltipItems,data){
                                                                
                                                             return data.labels[tooltipItems.index];
                                                            }}}});
               
        }

    },
    computed: {

    },
    mixins: [Doughnut],
    data(){

        return {
            is_loading: false,
            datacollection: {
                labels: ["orange", "Red", "blue"],
                datasets: [
                  {
                    label: "Data One",
                    backgroundColor: ["#034A81", "#F1631B"],
                    data: [1, 10]
                  }
                ],
            },
                // options: {
                //     scales: {
                //         yAxes: [{
                //             ticks: {
                //                 beginAtZero: true
                //             }
                //         }]
                //     },
                    
                // }
            
        }

    },
    mounted() {
        this.getDurationTypeCount();   
    }
 
};
</script>